/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type ServiceObjectMaintenanceStatusCreateV1Dto = {
  /**
   * ID of the contract associated with the maintenance status
   */
  contractId: string;
  /**
   * Interval for maintenance in combination with intervalUnit (e.g., 6 months)
   */
  interval: number;
  /**
   * Unit of the maintenance interval (e.g., Day, Week, Month, Year)
   */
  intervalUnit: ServiceObjectMaintenanceStatusCreateV1Dto.intervalUnit;
  /**
   * The next maintenance date. Must be after lastPerformedDate if it is provided.
   */
  nextDueDate?: string;
  /**
   * Notice period for the maintenance
   */
  notice: number;
  /**
   * Name of this status
   */
  name?: string;
};
export namespace ServiceObjectMaintenanceStatusCreateV1Dto {
  /**
   * Unit of the maintenance interval (e.g., Day, Week, Month, Year)
   */
  export enum intervalUnit {
    DAY = 'Day',
    WEEK = 'Week',
    MONTH = 'Month',
    YEAR = 'Year',
  }
}
